import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';

import favoriteBorderGlyph from 'assets/svg/favorite-border.svg';
import favoriteFilledGlyph from 'assets/svg/favorite-filled.svg';
import './favoriteIcon.scss';

interface Props {
    isActive: boolean;
}

const FavoriteIcon: React.FC<Props> = ({ isActive }) => {
    return (
        <Icon
            styleName={cn('icon ', {
                'is-active': isActive,
            })}
            className={cn('__app-FavoriteIcon-icon', {
                ['__app-FavoriteIcon-is-active']: isActive,
            })}
            glyph={isActive ? favoriteFilledGlyph : favoriteBorderGlyph}
        />
    );
};

export default React.memo(FavoriteIcon);
